import { inject } from '@angular/core';
import { BotsService } from '@core/bots';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { map, tap } from 'rxjs';

export const botExistGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const botsService = inject(BotsService);
  const router = inject(Router);

  return botsService.isBotExist$(Number(route.params['botId']))
                    .pipe(
                      map(value => value || router.createUrlTree(['/'])),
                    );
};
